var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35176 16.8356L4.31015 12.8622C3.92105 12.4796 3.29712 12.4796 2.90801 12.8622L2.72508 13.042C2.32651 13.4339 2.32651 14.0764 2.72508 14.4682L7.65069 19.3108C8.0398 19.6933 8.66373 19.6933 9.05283 19.3108L21.2744 7.29528C21.673 6.90343 21.673 6.26094 21.2744 5.86909L21.0915 5.68924C20.7024 5.3067 20.0785 5.3067 19.6894 5.68924L8.35176 16.8356Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.e1676d14.svg";
export { ForwardRef as ReactComponent };